import S from "./SingleDam.module.css";
import F from "./AllFarmsAdmin.module.css";
import G from "./ListDam.module.css";
import D from "../images/cow.svg";
import Gadjet from "../images/gadjet.svg";

import DeleteIcon from "@mui/icons-material/Delete";
import RateReviewIcon from "@mui/icons-material/RateReview";
import InfoIcon from "@mui/icons-material/Info";
import ReportIcon from "@mui/icons-material/Report";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import {
  CycloneOutlined,
  DateRange,
  DateRangeRounded,
  DeleteForever,
  Details,
  Edit,
  EventAvailable,
  Female,
  HomeWork,
  HorizontalSplitSharp,
  Sell,
  SensorDoor,
  Sensors,
  SplitscreenOutlined,
  TitleOutlined,
  TitleRounded,
} from "@mui/icons-material";
import NoSegmentLabels from "../Components/MyGauge";
import StChart from "../Components/StockChart";
import { useGlobalContext } from "../Components/Context";
import EditModalDam from "../Components/EditModalDam";
import { useEffect, useRef, useState } from "react";
import HistoryIcon from "@mui/icons-material/History";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccessC } from "../redux/slices/singleCattleSlice";
import DeleteCattle from "../Components/DeleteCattle";
import StChart2 from "../Components/StockChart2";
import AddComment from "../Components/AddCattleComment";
import { addComments } from "../redux/slices/commentsSlice";
import EditComment from "../Components/editCattleComment";
import apiService from "../api/ApiService";
import DeleteComm from "../Components/deleteComment";
import ChangePen from "../Components/changePenMOdal";
import CommentList from "../Components/cardThemes/CommentList";
import ChangeStatus from "../Components/ChangeCattleStatusModal";
import ChangeStatusCycle from "../Components/ChangeCattleCycleModal";
import { Pagination } from "@mui/material";
import { paginateCount, showUserExtra } from "../api/helper";
import { Col, Container, Row } from "react-bootstrap";
import EmptyReturn from "../Components/EmptyReturn";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import CommentsListComp from "./CommentsPageComp";
import MoveDetailStatus from "../Components/MoveDetailStatus";
const moment = require("moment-jalaali");
export const calculateDetails = (detailStatus, cattle, currentSit) => {
  const res = {
    name: cattle ? cattle?.cattleStatusTitle : currentSit?.newCattleStatusTitle,
    children: [],
  };
  detailStatus.map((item) => {
    if (
      item.id ===
      (item.id &
        (cattle ? cattle?.statusDetail : currentSit?.cattleStatusDetail))&&item?.id!=0
    ) {
      res.children.push({
        name: item?.description,
        value:
          item.id &
          (cattle ? cattle?.statusDetail : currentSit?.cattleStatusDetail),
      });
    }
  });
  return res;
};

const SingleDam = () => {
  const noteRef = useRef(null);
  const [show, setShow] = useState(false);
  const { currentCattle } = useSelector((state) => state.cattle);
  const { detailStatusList } = useSelector((state) => state.p.admin);
  const { currentTimeDiff, duration } = useSelector((state) => state.p.time);
  const [stats, setstats] = useState({});
  const {
    openModalls,
    isOpenModal,
    openDeleteModal,
    isDeleteModalOpen,
    openModallComment,
    isOpenModal2,
    openModalls2,
    openEditModallComment,
    openD,
    closeD,
    opens,
    openModallTime,
    isModalTimeOpen,
  } = useGlobalContext();
  const { closeWarn, isModalWarnOPen, openWarn } = useGlobalContext();
  const {offSet}=useSelector(state=>state.p.time);
  const [filterStatus, setFilterStatus] = useState([]);
  const { id } = useParams();
  const dispatch = useDispatch();

  const gett = () => {
    const d = calculateDetails(detailStatusList, currentCattle);
    setFilterStatus(d);
  };
  const getData = async () => {
    const res = await apiService.getCattle(id);

    const data = JSON.stringify({
      cattelId: id,
      date: currentTimeDiff,
      durationDay: duration,
      offSet:offSet,
    });
    const res2 = await apiService.getCattleStats(data);
    dispatch(loginSuccessC(res.data));
    setstats(res2.data);
  };

  useEffect(() => {
    getData();
  }, [id]);
  useEffect(() => {
    gett();
  }, [currentCattle]);
  return (
    <>
      <div className={S.SingleDamCon}>
        {/* <EditModalDam/> */}
        <div
          className="wraping"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className={S.SingleDamTitleCon}>
            <img className={S.SingleDamimgTit} src={D} />
            <h2>مشخصات دام</h2>
          </div>
          <div
            className="wraping"
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              justifySelf: "end",
            }}
          >
            <div className={S.EditBtnTableDam}>
              <Link
                to={`/Listdam/${id}/historyCycle`}
                data-title="  تاریخچه چرخه دام"
              >
                <CycloneOutlined
                  sx={{ fontSize: { xs: 26, sm: 30, md: 30, lg: 30 } }}
                />
              </Link>
            </div>
            <div className={S.EditBtnTableDam}>
              <Link to={`/Listdam/${id}/history`} data-title="  تاریخچه وضعیت">
                <HistoryIcon
                  sx={{ fontSize: { xs: 26, sm: 30, md: 30, lg: 30 } }}
                />
              </Link>
            </div>
            <div className={S.EditBtnTableDam}>
              <Link
                to={`/Listdam/${id}/historyParameter`}
                data-title="  تاریخچه پارامتر"
              >
                <ManageHistoryIcon
                  sx={{ fontSize: { xs: 26, sm: 30, md: 30, lg: 30 } }}
                />
              </Link>
            </div>
            <div
              data-title="لیست یادداشت ها"
              onClick={() =>
                noteRef.current.scrollIntoView({ behavior: "smooth" })
              }
              className={S.EditBtnTableDam}
            >
              <SpeakerNotesIcon
                sx={{ fontSize: { xs: 26, sm: 30, md: 30, lg: 30 } }}
              />
            </div>

            {showUserExtra&&<div
              onClick={openModalls}
              data-title="به روز رسانی"
              className={S.EditBtnTableDam}
            >
              <Edit sx={{ fontSize: { xs: 26, sm: 30, md: 30, lg: 30 } }} />
            </div>}
            {showUserExtra&&<div
              data-title="حذف"
              onClick={() => openDeleteModal()}
              className={S.DeleteBtnTableDam}
            >
              <DeleteIcon
                sx={{ fontSize: { xs: 26, sm: 30, md: 30, lg: 30 } }}
              />
            </div>}
          </div>
        </div>
        <hr />

        {
          <div className="showInfoTable">
            <div className={G.AnimContentLI}>
              <table>
                <thead>
                  <tr>
                    <th scope="col" className={S.LogoFormT}>
                      <div>
                        <span>
                          <ReportIcon />
                        </span>
                      </div>
                    </th>
                    <th scope="col" className={S.LogoFormT}>
                      <div>
                        <span>
                          <Details/>
                        </span>
                      </div>
                    </th>
                    <th scope="col" className={S.LogoFormT}>
                      <div>
                        <span>
                          <CycloneOutlined />
                        </span>
                      </div>
                    </th>
                    <th scope="col" className={S.LogoFormT}>
                      <div>
                        <span>
                          <Sell />
                        </span>
                      </div>
                    </th>
                    <th scope="col" className={S.LogoFormT}>
                      <div>
                        <span>
                          <Sell />
                        </span>
                      </div>
                    </th>
                    <th>
                      <div className="LogoFormT">
                        <div>
                          <span>
                            <img
                              style={{ width: "28px", height: "28px" }}
                              src={Gadjet}
                            />
                          </span>
                        </div>
                      </div>
                    </th>
                    <th className={S.LogoFormT}>
                      <div>
                        <span>
                          <EventAvailable />
                        </span>
                      </div>
                    </th>
                    <th scope="col" className={S.LogoFormT}>
                      <div>
                        <span>
                          <DateRange />
                        </span>
                      </div>
                    </th>
                    <th scope="col" className={S.LogoFormT}>
                      <div>
                        <span>
                          <HomeWork />
                        </span>
                      </div>
                    </th>
                    <th scope="col" className={S.LogoFormT}>
                      <div>
                        <span>
                          <Sensors />
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody style={{ margin: "0px auto" }}>
                  <tr>
                    <td className={S.TableFormTit}> وضعیت دام</td>
                    <td className={S.TableFormTit}> جزئیات</td>
                    <td className={S.TableFormTit}> چرخه دام</td>
                    <td className={S.TableFormTit}>شماره گوش</td>
                    <td className={S.TableFormTit}>شماره بدن</td>
                    <td className={S.TableFormTit}>شماره گردنبند</td>
                    <td className={S.TableFormTit}>جنسیت </td>
                    <td className={S.TableFormTit}>تاریخ تولد</td>
                    <td className={S.TableFormTit}>جایگاه </td>
                    <td className={S.TableFormTit}>کد دستگاه سنسور</td>
                  </tr>
                  <tr>
                    <td
                    >
                      <div className="d-flex gap-1 justify-content-center align-items-center position-relative">
                        {showUserExtra&&<div
                          onClick={openModallTime}
                          data-title="به روز رسانی"
                          className={S.EditBtnTableDam}
                        >
                          <Edit />
                        </div>}
                        <div>
                          {currentCattle && currentCattle?.cattleStatusTitle}
                        </div>
                      </div>
                    </td>
                    <td
                      onMouseOver={() => setShow(true)}
                      onMouseOut={() => setShow(false)}
                    >
                      <div  onClick={()=>{
                      openModalls2()
                    }} className='btnCardDAm'>جزئیات</div>
                    </td>
                    <td>
                      <div className="d-flex gap-1 justify-content-center align-items-center">
                        {showUserExtra&&<div
                          onClick={openWarn}
                          data-title="به روز رسانی"
                          className={S.EditBtnTableDam}
                        >
                          <Edit />
                        </div>}
                        <div>
                          {currentCattle && currentCattle?.cattleLifeCycleTitle}
                        </div>
                      </div>
                    </td>
                    <td>{currentCattle && currentCattle?.earTagNumber}</td>
                    <td>{currentCattle && currentCattle?.bodyNumber}</td>
                    <td>
                      {currentCattle && currentCattle?.sensor?.necklaceNumber}
                    </td>
                    <td>
                      {currentCattle && currentCattle?.gender === 2
                        ? "ماده"
                        : "نر"}
                    </td>
                    <td>
                      {currentCattle &&
                        moment(
                          currentCattle && currentCattle?.birthdate
                        ).format("jYYYY-jMM-jDD")}
                    </td>
                    <td style={{ verticalAlign: "center" }}>
                      {currentCattle && currentCattle?.pen?.name}
                    </td>
                    <td>
                      {currentCattle && currentCattle?.sensor?.deviceCode}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        }
        {
          <Container className="showInfoCard">
            <Row>
              <Col xs="6" sm="6">
                <div
                  className="cardItemCattle"
                  style={{ position: "relative" }}
                >
                  <div className={S.LogoFormT}>
                    <div>
                      <span>
                        <ReportIcon />
                      </span>
                    </div>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:"4px",alignItems:"center"}}>
                  <div>وضعیت دام</div>
                  <div className="d-flex gap-1 justify-content-center align-items-center">
                      <div
                        onClick={openModallTime}
                        data-title="به روز رسانی"
                        className={S.EditBtnTableDam}
                      >
                        <Edit fontSize="small" />
                      </div>
                      <div>
                        {currentCattle && currentCattle?.cattleStatusTitle}
                      </div>
                      <div  onClick={()=>{
openModalls2()
                    }} className='btnCardDAm' style={{fontSize:"8px"}}>جزئیات</div>
                    </div>
                  
                  </div>
                  <div>
                    
                  </div>
                </div>
              </Col>
              <Col xs="6" sm="6" md="6">
                <div className="cardItemCattle">
                  <div className={S.LogoFormT}>
                    <div>
                      <span>
                        <CycloneOutlined />
                      </span>
                    </div>
                  </div>
                  <div>چرخه دام</div>
                  <div>
                    <div className="d-flex gap-1 justify-content-center align-items-center">
                      <div
                        onClick={openWarn}
                        data-title="به روز رسانی"
                        className={S.EditBtnTableDam}
                      >
                        <Edit fontSize="small" />
                      </div>
                      <div>
                        {currentCattle && currentCattle?.cattleLifeCycleTitle}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs="6" sm="6" md="6">
                <div className="cardItemCattle">
                  <div className={S.LogoFormT}>
                    <div>
                      <span>
                        <Sell />
                      </span>
                    </div>
                  </div>
                  <div> شماره گوش</div>
                  <div>
                    <div className="d-flex gap-1 justify-content-center align-items-center">
                      <div>{currentCattle && currentCattle?.earTagNumber}</div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs="6" sm="6" md="6">
                <div className="cardItemCattle">
                  <div className={S.LogoFormT}>
                    <div>
                      <span>
                        <Sell />
                      </span>
                    </div>
                  </div>
                  <div> شماره بدن</div>
                  <div>
                    <div className="d-flex gap-1 justify-content-center align-items-center">
                      <div>{currentCattle && currentCattle?.bodyNumber}</div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs="6" sm="6" md="6">
                <div className="cardItemCattle">
                  <div className={S.LogoFormT}>
                    <div>
                      <span>
                        <Sell />
                      </span>
                    </div>
                  </div>
                  <div> شماره گردنبند</div>
                  <div>
                    <div className="d-flex gap-1 justify-content-center align-items-center">
                      <div>
                        {currentCattle && currentCattle?.sensor?.necklaceNumber}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs="6" sm="6" md="6">
                <div className="cardItemCattle">
                  <div className={S.LogoFormT}>
                    <div>
                      <span>
                        <EventAvailable />
                      </span>
                    </div>
                  </div>
                  <div> جنسیت</div>
                  <div>
                    <div className="d-flex gap-1 justify-content-center align-items-center">
                      <div>
                        {currentCattle && currentCattle?.gender === 2
                          ? "ماده"
                          : "نر"}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs="6" sm="6" md="6">
                <div className="cardItemCattle">
                  <div className={S.LogoFormT}>
                    <div>
                      <span>
                        <DateRange />
                      </span>
                    </div>
                  </div>
                  <div> تاریخ تولد</div>
                  <div>
                    <div className="d-flex gap-1 justify-content-center align-items-center">
                      <div>
                        {currentCattle &&
                          moment(
                            currentCattle && currentCattle?.birthdate
                          ).format("jYYYY-jMM-jDD")}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs="6" sm="6" md="6">
                <div className="cardItemCattle">
                  <div className={S.LogoFormT}>
                    <div>
                      <span>
                        <HomeWork />
                      </span>
                    </div>
                  </div>
                  <div> جایگاه</div>
                  <div>
                    <div className="d-flex gap-1 justify-content-center align-items-center">
                      <div>{currentCattle && currentCattle?.pen?.name}</div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs="6" sm="6" md="6">
                <div className="cardItemCattle">
                  <div className={S.LogoFormT}>
                    <div>
                      <span>
                        <Sensors />
                      </span>
                    </div>
                  </div>
                  <div> کد سنسور</div>
                  <div>
                    <div className="d-flex gap-1 justify-content-center align-items-center">
                      <div>
                        {currentCattle && currentCattle?.sensor?.deviceCode}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        }
        <div style={{ margin: "40px auto", direction: "ltr" }}>
          <NoSegmentLabels
            averageStat={stats && stats.averageStat}
            day30={stats && stats?.cattle30DaysStats}
            chart={stats && stats.cattle24HoursStat}
            hour8={stats && stats?.cattleEvery8HoursStats}
            hours720={stats && stats?.cattle720HoursStats}
            label={"دام"}
          />
        </div>
      </div>

      <div
        className="wraping"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "95%",
          direction: "rtl",
        }}
      >
        <div className={S.SingleDamTitleCon}>
          <img className={S.SingleDamimgTit} src={D} />
          <h2 ref={noteRef}>یادداشت های دام</h2>
        </div>
        <div
          className="wraping"
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            justifySelf: "end",
          }}
        >
          <div
            title="افزودن یادداشت"
            onClick={openModallComment}
            className={S.EditBtnTableDam}
          >
            <RateReviewIcon
              sx={{ fontSize: { xs: 26, sm: 30, md: 30, lg: 30 } }}
            />
          </div>
        </div>
      </div>
      <hr style={{ width: "100%" }} />
      <CommentsListComp flag={"cattle"} />
      {/* {isModalCommentOpen&&<AddComment flag={"cattle"} />} */}
      {/* {!currentTheme&&isModalEditCommentOpen&&<EditComment selected={selected} flag={"cattle"} />}
    {!currentTheme&&opens&&<DeleteComm penr={comId} type={"cattle"}/>} */}

      {isOpenModal && <EditModalDam data={currentCattle} />}
      {isDeleteModalOpen && <DeleteCattle />}
      {isModalTimeOpen && (
        <ChangeStatus
          tit={currentCattle?.cattleStatusTitle}
          idd={currentCattle?.cattleStatusId}
        />
      )}
      {isModalWarnOPen && (
        <ChangeStatusCycle
          tit={currentCattle?.cattleLifeCycleTitle}
          idd={currentCattle?.cattleLifeCycleId}
        />
      )}
      {isOpenModal2&&<MoveDetailStatus seenFlag={false} flag={"status"} SData={currentCattle} data1={filterStatus}/>}
    </>
  );
};

export default SingleDam;
